import { UserLogin, UserBrief, UserActivityAuth, UserMediaAccount, RealName, AnnounceQqlist, DownloadAccess } from 'Services/getData.js';
import responseCode from 'Services/responseCode';

export default {
    async getUserBrief ({
        commit,
        state
    }) {
        let res = await UserBrief();
        if (res.status === 200 && res.data.code == responseCode.noTglUser) {
            res = await UserLogin();
        }
        if (res.status === 200 && res.data.code == 0 ) {
            commit('SAVE_USERBREIF', res.data.data);            
        }
        return res;
    },
    async getUserInfo ({
        commit,
        state
    }) {
        let res = await RealName();
        if (res.status === 200 && res.data.code == 0 ) {
            commit('SAVE_USERINFO', res.data.data);            
        }
        return res;
    },
    async getNotice ({
        commit,
        state
    }) {
        let res = await AnnounceQqlist();
        if (res.status === 200 && res.data.code == 0 ) {
            commit('SAVE_NOTICE', res.data.data);            
        }
        return res;
    },
    async getUserActivityAuth ({
        commit,
        state
    }, params) {
        const res = await UserActivityAuth({signature: params.sig});
        if (res.status === 200 && res.data.code == 0) {
            commit('SAVE_ACTIVITY', {name: params.sig, requiredAccounts: res.data.data});
        }
        return res;
    },
    async getUserMediaAccounts ({
        commit,
        state
    }) {
        const res = await UserMediaAccount();
        if (res.status === 200 && res.data.code == 0) {
            commit('SAVE_MEDIA_ACCOUNT', res.data.data);
        }
        return res;
    },
    async getAuth ({
        commit,
        state
    }) {
        let res = await DownloadAccess()
        if(res.status === 200 && res.data.code === 0){
            commit('getAuth', res.data.data);
        }
        return res;
    }
};
